var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.625 134.75H30.625C18.375 134.75 12.25 128.625 12.25 116.375V67.3749C12.25 55.1249 18.375 48.9999 30.625 48.9999H61.25V116.375C61.25 128.625 67.375 134.75 79.625 134.75Z",
    stroke: "#00A6A6",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9246 24.5C61.4346 26.3375 61.251 28.3587 61.251 30.625V49H30.626V36.75C30.626 30.0125 36.1385 24.5 42.876 24.5H61.9246Z",
    stroke: "#00A6A6",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7529 48.9999V79.6249",
    stroke: "#292D32",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.247 48.9999V79.6249",
    stroke: "#292D32",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.128 104.125H91.8779C88.5092 104.125 85.7529 106.881 85.7529 110.25V134.75H110.253V110.25C110.253 106.881 107.497 104.125 104.128 104.125Z",
    stroke: "#00A6A6",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.751 79.6251V104.125",
    stroke: "#292D32",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.252 116.375V30.625C61.252 18.375 67.377 12.25 79.627 12.25H116.377C128.627 12.25 134.752 18.375 134.752 30.625V116.375C134.752 128.625 128.627 134.75 116.377 134.75H79.627C67.377 134.75 61.252 128.625 61.252 116.375Z",
    stroke: "#00A6A6",
    strokeWidth: 9.23286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.ec30b94723ca5e5a568d7b39535abd02.svg";
export { ForwardRef as ReactComponent };